import { render, staticRenderFns } from "./my-resources-home.vue?vue&type=template&id=4ec261d2&scoped=true&"
import script from "./my-resources-home.vue?vue&type=script&lang=js&"
export * from "./my-resources-home.vue?vue&type=script&lang=js&"
import style0 from "./my-resources-home.vue?vue&type=style&index=0&id=4ec261d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec261d2",
  null
  
)

export default component.exports